import { useParams } from 'react-router-dom';

export type PageTab = 'cards' | 'lists';

export function useActivePageTab(): PageTab {
  const { activeTab } = useParams<{ activeTab: PageTab }>();
  return activeTab;
}
